import { Container } from '../ui/Container'
import { CTA } from '../ui/CTA'
import { Reveal } from '../ui/Reveal'

export function FinalCTA() {
  return (
    <section className="bg-night py-24 text-snow md:py-32">
      <Container>
        <Reveal className="mx-auto max-w-2xl text-center">
          <h2 className="font-display text-4xl font-semibold leading-tight tracking-tight text-balance md:text-6xl">
            Have something worth building?
          </h2>
          <p className="mx-auto mt-6 max-w-lg text-base leading-relaxed text-snow/70">
            Tell us what you&apos;re trying to solve, improve, or build. Whether you&apos;re launching
            something new, rebuilding what already exists, or trying to make your business work
            better, let&apos;s understand the problem.
          </p>
          <div className="mt-10 flex justify-center">
            <CTA to="/contact" variant="primaryOnDark">
              Let&apos;s talk
            </CTA>
          </div>
        </Reveal>
      </Container>
    </section>
  )
}
